export const checkURLImage = async (url: string) => {
  let isValid = false
  const res = await fetch(url, { method: "GET" }).catch((e) => console.log("e", e))
  if (res?.ok) {
    isValid = true;
  }
  return isValid
};
